import { useEffect, useMemo, useRef, useState } from "react";
import { Button, ColorPicker, Grid, Modal, Popover, Slider, Spin } from "antd";
import { VideoWrapper } from "components/video-wrapper/indexv1";
import { getTimeStamps } from "components/visualize-wrapper/helpers";
import { BaseballSeekbar } from "components/baseball-seek-bar";
import { BaseballTiles, TracerButtons, TwodD } from "./components";
import { ConditionalRenderer } from "components";
import { useGetInitialData } from "./hooks/useGetInitialData";
import {
  calculateBaseballGraphTimeValues,
  getBaseballTilesData,
  getBseballPvalueIndexes,
  handleDownloadJsonUrl,
  isDrawingActive,
} from "./helpers";
import { DownloadButtons } from "./components/downloadButtons";
import { tracerBtnsData } from "./constants";
import styles from "./styles.module.scss";
import { UseApiCallSimulation } from "hooks/use-api-call-simulation";
import { UseLazyApiCallSimulation } from "hooks/use-lazy-api-call-simulation";
import { TracerColorIcon } from "./iconComponents/tracerColorIcon";
import { ModalCloseIcon, WolfIconForSideMenu } from "icons";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useVideoFramesV2 } from "hooks/use-video-frames-v2/index.js";
import { getVideoHeight } from "utils/helpers";

const { useBreakpoint } = Grid;
export const SimulationVisualize = ({
  fileId,
  extractionProgress,
  faceonVideoImages,
  videoAllData,
  videoAllDataLoading,
  videoAllDataError,
}) => {
  const screens = useBreakpoint();
  const visualizeContainerRef = useRef();
  const fileIdWithoutExtension = fileId?.replace(".mp4", "");
  const [timeStamps, setTimeStamps] = useState([]);
  const [isReadyToPlay, setIsReadyToPlay] = useState(true);
  const [currentFrame, setCurrentFrame] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [positionTimestamps, setPositionTimestamps] = useState([]);
  const [graphTimeVlaues, setGraphTimeVlaues] = useState([]);
  const [framesData, setFramesData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [timeAtEveryPosition, setTimeAtEveryPosition] = useState();
  const [videoDuration, setVideoDuration] = useState(0);
  const [heightOfContainer, setHeightOfContainer] = useState(null);

  const colorFromLocalStorage = localStorage.getItem("baseballTracerColor")
    ? JSON.parse(localStorage.getItem("baseballTracerColor"))
    : "red";

  const thicknessFromLocalStorage =
    localStorage.getItem("tracerThickness") || 3;

  const [colorAndThicknessLocal, setColorAndThicknessLocal] = useState({
    color: colorFromLocalStorage || "red",
    thickness: thicknessFromLocalStorage || 3,
  });
  const [colorAndThicknessFinal, setColorAndThicknessFinal] = useState({
    color: colorFromLocalStorage || "red",
    thickness: thicknessFromLocalStorage || 3,
  });

  const [isTracerColorModalOpen, setIsTracerColorModal] = useState(false);

  const [isSideMenuExpanded, setIsSideMenuExpanded] = useState(false);

  function handleClickSideMenu() {
    setIsSideMenuExpanded((prev) => !prev);
  }

  useEffect(() => {
    setTimeAtEveryPosition(timeStamps[currentFrame]);
  }, [currentFrame]);

  const { downloadBtns } = useGetInitialData({
    fileid: fileIdWithoutExtension,
  });

  // Destructuring
  const {
    duration,
    chunks,
    configuration: {
      capturing: {
        frame_count,
        frame_rate,
        width: videoWidth,
        height: videoHeight,
      } = {},
      movement: { movement_type } = {},
    } = {},
    critical_events,
    url: videoSrc,
  } = videoAllData || {};
  const TilesData = useMemo(
    () => getBaseballTilesData({ videoAllData }),
    [videoAllData],
  );

  useEffect(() => {
    if (!videoSrc) return;

    const video = document.createElement("video");
    video.preload = "metadata";
    video.src = videoSrc;

    const handleMetadata = () => {
      setVideoDuration(video.duration);
    };

    video.addEventListener("loadedmetadata", handleMetadata);
    return () => video.removeEventListener("loadedmetadata", handleMetadata);
  }, [videoSrc]);

  // const {
  //   frames: faceonVideoImages,
  //   cleanUpFrames: faceonCleanUpFrames,
  //   extractFrames: faceonExtractFrames,
  //   extractionProgress,
  // } = useVideoFramesV2({
  //   videoSrc,
  //   frameRate: frame_rate,
  // });
  // useEffect(() => {
  //   if (videoSrc && videoDuration > 0 && frame_rate) {
  //     faceonExtractFrames();
  //   }
  // }, [videoSrc, videoDuration, frame_rate]);

  console.log({ videoAllData });

  useEffect(() => {
    if (!videoHeight || !videoWidth) return;

    function updateHeight() {
      const { width, height } =
        visualizeContainerRef.current?.getBoundingClientRect() || {};
      if (!screens.xxl) {
        const heightCal = getVideoHeight({
          width, //
          height,
          videoHeight,
          videoWidth,
        });

        setHeightOfContainer(Number(heightCal?.replace("px", "")));

        console.log({ heightCal });
      }

      console.log({ videoHeight, videoWidth, width, height }, "====");
    }
    updateHeight();

    window.addEventListener("resize", updateHeight);
  }, [screens, videoHeight, videoWidth]);

  const positions = videoAllData?.critical_events;
  useEffect(() => {
    if (positions) {
      setCurrentFrame(positions[firstPositionKey] || 0);
    }
  }, [positions]);
  const firstPositionKey = movement_type === "batter" ? "p1" : "set" || 0;
  const lastPositionKey =
    movement_type === "batter"
      ? "p6"
      : "finish" || videoAllData?.configuration?.capturing?.frame_count;
  const handSpeedData = videoAllData?.hand_speed_graph?.slice(
    positions[firstPositionKey],
    positions[lastPositionKey] + 1,
  );

  useEffect(() => {
    if (positions) {
      const graphTimeVlauesLocal = calculateBaseballGraphTimeValues({
        positions,
        timeStamps,
        firstPositionKey,
        lastPositionKey,
      });
      const pvalueIndexes =
        getBseballPvalueIndexes(positions, positions[firstPositionKey]) || {};
      const positionTimestamps = Object.values(pvalueIndexes).map(
        (index) => graphTimeVlauesLocal[index],
      );
      setGraphTimeVlaues(graphTimeVlauesLocal);
      setPositionTimestamps(positionTimestamps);
    }
  }, [positions, timeStamps]);

  useEffect(() => {
    if (videoAllDataError?.message) {
      setIsReadyToPlay(true);
    }
  }, [videoAllDataError]);

  const [tracerBtns, setTracerBtns] = useState(tracerBtnsData);

  const isTwoDActive = useMemo(
    () => isDrawingActive({ key: "tracking", tracerBtns }),
    [tracerBtns],
  );
  const ishandTracerActive = useMemo(
    () => isDrawingActive({ key: "handTracer", tracerBtns }),
    [tracerBtns],
  );

  useEffect(() => {
    const totalTimestamps = getTimeStamps(frame_rate, frame_count);
    setTimeStamps(totalTimestamps);
  }, [videoAllData]);

  function videoPlayOrPause() {
    if (!isPlaying) return;
    return setInterval(() => {
      setCurrentFrame((prevFrame) => {
        const nextFrame = prevFrame + 1;
        let finalFrame = timeStamps.length;

        if (nextFrame >= finalFrame) {
          setIsPlaying(false);
          // Stop playback when reaching the last frame in case of complete frames
          return 0;
        }
        return nextFrame;
      });
    }, 120);
  }

  useEffect(() => {
    const interval = videoPlayOrPause();
    return () => {
      clearInterval(interval);
    };
  }, [isPlaying]);

  function handlePreviousFrame() {
    setCurrentFrame((prevFrame) => prevFrame - 1);
    setIsPlaying(false);
  }

  function handleNextFrame() {
    setCurrentFrame((prevFrame) => prevFrame + 1);
    setIsPlaying(false);
  }
  function handleSliderChange(e) {
    const frameIndex = parseInt(e.target.value);
    setCurrentFrame(frameIndex);
  }

  // function handleChangeFrame(delta) {
  //   setCurrentFrame((prevFrame) => Math.max(0, prevFrame + delta));
  //   setIsPlaying(false);
  // }

  function handlePlay() {
    setIsPlaying((prevState) => !prevState);
  }

  function handleClickTracerBtn(btnData) {
    setTracerBtns((prevState) => {
      return prevState.map((item) => {
        return item.key === btnData.key
          ? {
              ...btnData,
              active: !item.active,
            }
          : item;
      });
    });
  }

  function handleChangeColor(color) {
    const hexColor = color.toHexString();
    setColorAndThicknessLocal({
      ...colorAndThicknessLocal,
      color: hexColor,
    });
  }

  function heightOfAllIcons() {
    const hieghtOfIcon = 45;
    const numberOfIcons = 8;
    const gap = 15;
    const heightOfContainer =
      hieghtOfIcon * numberOfIcons + gap * numberOfIcons;
    return heightOfContainer;
  }

  function handleChangeThickness(value) {
    setColorAndThicknessLocal({
      ...colorAndThicknessLocal,
      thickness: value,
    });
  }

  function handleConfirmTracerColorModal() {
    const { color, thickness } = colorAndThicknessLocal;
    setColorAndThicknessFinal({
      color,
      thickness,
    });
    localStorage.setItem("tracerThickness", JSON.stringify(thickness));
    localStorage.setItem("baseballTracerColor", JSON.stringify(color));
    setIsTracerColorModal(false);
  }

  function handleCancelChange() {
    setColorAndThicknessLocal({
      ...colorAndThicknessFinal,
    });
    // setIsTracerColorModal(false);
  }

  return (
    <Spin
      // spinning={false}
      spinning={videoAllDataLoading || !isReadyToPlay}
    >
      <div className={styles.visualizeContainer} ref={visualizeContainerRef}>
        <ConditionalRenderer condition={videoAllData}>
          <div className={styles.actionLabelsContainer}>
            <div
              className={styles.sideMenu}
              style={{
                backgroundColor: "white",
                borderRadius: "10px",
                height: "fit-content",
              }}
            >
              <div
                className={styles.wrapper}
                style={{
                  position: "relative",
                  textAlign: "center",
                  // height: isSideMenuExpanded
                  //   ? `${heightOfAllIcons()}px`
                  //   : "250px",
                }}
              >
                <WolfIconForSideMenu className={styles.wolf} />
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "-15px",
                    color: "white",
                    zIndex: "11",
                    height: "25px",
                    width: "25px",
                    cursor: "pointer",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    border: "1px solid #E2E8F0",
                  }}
                  onClick={handleClickSideMenu}
                >
                  <RightOutlined
                    style={{
                      color: "black",
                      fontSize: "10px",
                      transform: isSideMenuExpanded && "rotate(180deg)",
                      transition: "all ease 0.3s",
                    }}
                  />
                </div>
                <div className={styles.actionBtns}>
                  <ConditionalRenderer condition={isSideMenuExpanded}>
                    <DownloadButtons
                      downloadBtns={downloadBtns}
                      fileid={fileIdWithoutExtension}
                      handleDownloadJsonUrl={handleDownloadJsonUrl}
                    />
                  </ConditionalRenderer>

                  <TracerButtons
                    isSideMenuExpanded={isSideMenuExpanded}
                    tracerBtns={tracerBtns}
                    handleClickTracerBtn={handleClickTracerBtn}
                  />
                  {/* <ConditionalRenderer condition={isSideMenuExpanded}> */}
                  {/* <Popover
                      trigger="click"
                      open={isTracerColorModalOpen}
                      placement="rightTop"
                      content={
                        <TracerColorPopOverContent
                          handleChangeColor={handleChangeColor}
                          setIsTracerColorModal={setIsTracerColorModal}
                          colorAndThicknessLocal={colorAndThicknessLocal}
                          colorAndThicknessFinal={colorAndThicknessFinal}
                          handleChangeThickness={handleChangeThickness}
                          handleConfirmTracerColorModal={
                            handleConfirmTracerColorModal
                          }
                        />
                      }
                    >
                      <div
                        className={styles.tracerColorIcon}
                        onClick={() =>
                          setIsTracerColorModal(!isTracerColorModalOpen)
                        }
                      >
                        <TracerColorIcon />
                      </div>
                    </Popover> */}
                  <ColorPicker
                    onClear={() => alert("hi")}
                    trigger="click"
                    open={isTracerColorModalOpen}
                    onChange={handleChangeColor}
                    panelRender={(panel) => (
                      <div className="custom-panel">
                        <div className={styles.colorInputRow}>
                          <h4>Tracer Width</h4>
                          <Slider
                            defaultValue={colorAndThicknessFinal.thickness}
                            className={styles.slider}
                            value={colorAndThicknessLocal.thickness}
                            min={1}
                            max={10}
                            onChange={handleChangeThickness}
                            tooltip
                          />
                        </div>

                        {panel}

                        <div className={styles.modalButtons}>
                          <Button
                            className={styles.modalYesButton}
                            type="primary"
                            onClick={handleConfirmTracerColorModal}
                          >
                            Done
                          </Button>
                        </div>
                      </div>
                    )}
                    value={colorAndThicknessLocal.color}
                  >
                    <div
                      className={styles.tracerColorIcon}
                      onClick={(prev) => {
                        if (prev) handleCancelChange();
                        setIsTracerColorModal(!isTracerColorModalOpen);
                      }}
                    >
                      <TracerColorIcon />
                    </div>
                  </ColorPicker>
                  {/* </ConditionalRenderer> */}
                  {/* <ConditionalRenderer condition={isSideMenuExpanded}>
                    <ColorPicker value={color} onChange={handleChangeColor}>
                      <div className={styles.tracerColorIcon}>
                        <TracerColorIcon />
                      </div>
                    </ColorPicker>
                  </ConditionalRenderer> */}
                </div>
              </div>
            </div>

            <div className={styles.tilesContainer}>
              <BaseballTiles TilesData={TilesData} />
            </div>
          </div>
        </ConditionalRenderer>
        <VideoWrapper
          // containerHeight={visualizeContainerRef?.current?.clientHeight}
          containerHeight={heightOfContainer}
          videoSrc={videoSrc}
          setIsReadyToPlay={setIsReadyToPlay}
          timestamps={timeStamps}
          currentFrame={currentFrame}
          isPlaying={isPlaying}
          isLandscape
          ratio={Number(videoWidth / videoHeight)}
          isLoading={isLoading}
          extractionProgress={extractionProgress}
          activeExtraction
          framesData={faceonVideoImages}
        />
        <ConditionalRenderer condition={videoAllData}>
          <BaseballSeekbar
            handleNextFrame={handleNextFrame}
            handlePreviousFrame={handlePreviousFrame}
            handleSliderChange={handleSliderChange}
            handlePlay={handlePlay}
            currentFrame={currentFrame}
            isReadyToPlay={isReadyToPlay}
            isPlaying={isPlaying}
            timestamps={timeStamps}
            setCurrentFrame={setCurrentFrame}
            isBaseBallVariant
            totalCount={frame_count}
            fps={frame_rate}
            positions={critical_events}
            timeBarDuration={duration}
            positionTimestamps={positionTimestamps}
            handSpeedData={handSpeedData}
            graphTimeVlaues={graphTimeVlaues}
            timeAtEveryPosition={timeAtEveryPosition}
            movement_type={movement_type}
            isLoading={isLoading}
            min={0}
            max={timeStamps?.length - 1}
          />
        </ConditionalRenderer>

        <ConditionalRenderer condition={videoAllData?.pose}>
          <TwodD
            allData={videoAllData}
            currentFrame={currentFrame}
            positions={critical_events}
            isTwoDActive={isTwoDActive}
            ishandTracerActive={ishandTracerActive}
            movement_type={movement_type}
            tracerColor={colorAndThicknessFinal?.color}
            strokeWidth={colorAndThicknessFinal?.thickness}
          />
        </ConditionalRenderer>
      </div>
    </Spin>
  );
};

function TracerColorPopOverContent({
  handleChangeColor,
  setIsTracerColorModal,
  colorAndThicknessLocal,
  handleChangeThickness,
  handleConfirmTracerColorModal,
  colorAndThicknessFinal,
}) {
  return (
    <div style={{ width: "400px" }}>
      <div
        style={{ textAlign: "end", cursor: "pointer" }}
        onClick={() => setIsTracerColorModal(false)}
      >
        <ModalCloseIcon />
      </div>

      <div className={styles.colorInputRow}>
        <h3>Color</h3>
        <ColorPicker
          value={colorAndThicknessLocal.color}
          onChange={handleChangeColor}
          defaultValue={colorAndThicknessFinal.color}
        />
      </div>

      <div className={styles.colorInputRow}>
        <h3>Thickness</h3>
        <Slider
          defaultValue={colorAndThicknessFinal.thickness}
          className={styles.slider}
          value={colorAndThicknessLocal.thickness}
          min={1}
          max={10}
          onChange={handleChangeThickness}
          tooltip
        />
      </div>

      <div className={styles.modalButtons}>
        <Button
          className={styles.modalYesButton}
          type="primary"
          onClick={handleConfirmTracerColorModal}
        >
          Done
        </Button>
      </div>
    </div>
  );
}
